import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
//UI-components
import { Box, Divider, Grid } from '@mui/material';
import { Prompt } from 'react-router-dom';
import ApprovalLevelComponent from './ApprovalLevelComponent';

const ApprovalLevelListComponent = ({
  t,
  approvalLevels,
  decisionTypes,
  applying,
  onPropertyChange,
  onSaveItem,
  onApplyItem,
  showApprovalHistory,
  currentUserId,
  setQueueSaveForIndex,
  decisionReasons,
  selectedOffer
}) => {
  return (
    <Grid container spacing={1}>
      <Prompt when={approvalLevels.some(x => x?.dirtyInfo?.isDirty)} message={() => t('LeavingWithoutSaving')} />
      {approvalLevels.map(({ document, dirtyInfo, validationInfo }, index) => {
        return (
          <>
            <ApprovalLevelComponent
              key={document.approvalLevelId}
              decisionTypes={decisionTypes}
              decisionReasons={decisionReasons}
              applying={applying}
              onPropertyChange={onPropertyChange}
              onSave={onSaveItem}
              onApply={onApplyItem}
              index={index}
              level={document}
              dirtyInfo={dirtyInfo}
              validationInfo={validationInfo}
              showApprovalHistory={showApprovalHistory}
              setQueueSaveForIndex={setQueueSaveForIndex}
              selectedOffer={selectedOffer}
              lastApprovalIndex={approvalLevels.length - 1}
              userIsOnCurrentLevel={
                currentUserId !== null &&
                currentUserId !== undefined &&
                !!document.usersEligibleToDecide?.some(x => x.userId === currentUserId)
              }
              userIsOnPreviousLevel={
                index === 0
                  ? true
                  : currentUserId !== null &&
                    currentUserId !== undefined &&
                    !!approvalLevels[index - 1].document.usersEligibleToDecide?.some(x => x.userId === currentUserId)
              }
              userIsRequestedUser={
                currentUserId !== null && currentUserId !== undefined && document.requestedApprovalUserId === currentUserId
              }
              anyOtherLevelHasReason={approvalLevels.some(
                x => x.document.decisionReasonId && x.document.approvalLevelId !== document.approvalLevelId
              )}
            />
            {index < approvalLevels.length - 1 && (
              <Box width='100%'>
                <Divider />
              </Box>
            )}
          </>
        );
      })}
    </Grid>
  );
};

ApprovalLevelListComponent.propTypes = {
  approvalLevels: PropTypes.array.isRequired,
  decisionTypes: PropTypes.array.isRequired,
  applying: PropTypes.bool.isRequired,
  onPropertyChange: PropTypes.func.isRequired,
  onSaveItem: PropTypes.func.isRequired,
  onApplyItem: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  currentUserId: PropTypes.number,
  showApprovalHistory: PropTypes.func.isRequired,
  setQueueSaveForIndex: PropTypes.func.isRequired,
  selectedOffer: PropTypes.object,
  decisionReasons: PropTypes.array
};

export default withTranslation()(ApprovalLevelListComponent);
